import React, { useState, useEffect, useRef } from 'react';

import { useLocation, Link } from 'react-router-dom';

import { motion } from "framer-motion";

import images from '../libs/images';
import consts from '../libs/consts';
import routes from '../libs/routes';

import { usePopup, useUser } from "../zustand/store.js";

import Image from './Image';
import { LangText } from '../zustand/dict.js';


import { numFormat } from "../utils/utils";

export default function Credits() {

    const location = useLocation();

    const ref = useRef();

    const { creditsPop, toggleCreditsPop } = usePopup();
    const { user } = useUser();
    
    useEffect(() => {

        if(creditsPop) toggleCreditsPop();
        
    }, [location.pathname]);

    useEffect(()=> {
        const handleOutsideClose = (e) => {
            if(creditsPop && (!ref?.current?.contains(e.target))) toggleCreditsPop();
        };

        document.addEventListener('click', handleOutsideClose);
        
        return () => document.removeEventListener('click', handleOutsideClose);

    }, [creditsPop]);

    const clickFunc = (v) => {

        // setData({key: 'language', value: v});

        toggleCreditsPop();
    }

    return (
        <div
            ref={ref} 
            className={`header_pop ${consts.animationFadeIn}`}
        >
            <p className='credits_title' onClick={toggleCreditsPop}>{numFormat(user?.point)} <LangText id={'text_credit'} /></p>
            <p className='credits_title_m' onClick={toggleCreditsPop}></p>

            <motion.div 
                className='header_pop_box etc_list'
                initial={consts.headerVariants.closed}
                animate={creditsPop ? "open" : "closed"}
                variants={consts.headerVariants}
            >
                <div className='top'>
                    <div className='credits_left'>
                        <p className='title'>
                            <LangText id={'text_remaining_credit'}/>
                        </p>
                        <p className='comment'>{numFormat(user?.point)}</p>
                    </div>

                    <Link className='link_text' to={routes.pay}>
                        <LangText id={'text_buy'} />
                    </Link>
                </div>
                <ul className='list'>
                    <li>
                        <Link className='title link' to={routes.pay_history}>
                            <LangText id={'usage history'} />
                        </Link>
                    </li>
                </ul>
            </motion.div>
        </div>
    )    
}